import React from 'react';
import { Variant, Size } from './types';
import { IconButtonStyled } from './iconButton.styled';

import SvgIcon from '../SvgIcon';

interface IconButtonProps {
  variant?: keyof typeof Variant;
  // TODO: set medium size as a default
  // TODO: Create mapping for SvgIcon size
  size?: keyof typeof Size;
  icon?: React.ReactNode;
  rounded?: boolean;
  disabled?: boolean;
  mr?: number;
  onClick?: (event: React.MouseEvent<HTMLElement>) => void;
}

const IconButton = ({
  rounded = true,
  icon,
  size,
  disabled,
  ...props
}: IconButtonProps) => {
  // TODO: alex redesign color system
  let iconColor = 'wfWhite';
  if (props.variant === Variant.outlined) iconColor = 'wfBlack';

  return (
    <IconButtonStyled
      size={size}
      rounded={rounded}
      disabled={disabled}
      {...props}
    >
      {/* @ts-ignore */}
      <SvgIcon icon={icon} color={iconColor} size='small' />
    </IconButtonStyled>
  );
};

export default IconButton;
